// import React, { useEffect, useState } from "react";
// import {
//   Grid,
//   Typography,
//   Paper,
//   Box,
//   Button,
//   Chip,
//   Divider,
//   Stack,
//   Avatar,
//   CircularProgress,
//   alpha,
// } from "@mui/material";
// import { useParams, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import MainCard from "ui-component/cards/MainCard";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import PendingActionsIcon from "@mui/icons-material/PendingActions";
// import swal from "sweetalert";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// const MaterialEntryExitDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const API = process.env.REACT_APP_API_URL;
//   const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

//   const [materialPermit, setMaterialPermit] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [updatingStatus, setUpdatingStatus] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);

//   const formatDate = (date) => {
//     if (!date) return "-";
//     return new Date(date).toLocaleString("en-IN", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const getStatusChip = (status) => {
//     const base = {
//       fontWeight: 500,
//       px: 1.5,
//       py: 0.5,
//       borderRadius: "12px",
//       fontSize: "0.8rem",
//     };
//     switch (status) {
//       case "accept":
//         return (
//           <Chip
//             icon={<CheckCircleIcon />}
//             label="Accepted"
//             sx={{ ...base, backgroundColor: alpha("#4caf50", 0.15), color: "#2e7d32" }}
//           />
//         );
//       case "reject":
//         return (
//           <Chip
//             icon={<CancelIcon />}
//             label="Rejected"
//             sx={{ ...base, backgroundColor: alpha("#f44336", 0.15), color: "#b71c1c" }}
//           />
//         );
//       default:
//         return (
//           <Chip
//             icon={<PendingActionsIcon />}
//             label="Pending"
//             sx={{ ...base, backgroundColor: alpha("#ffeb3b", 0.25), color: "#7c6f00" }}
//           />
//         );
//     }
//   };

//   const fetchMaterialPermit = async () => {
//     try {
//       const res = await fetch(`${API}material-permit-details/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await res.json();
//       if (res.ok && data?.data?.materialPermit) {
//         setMaterialPermit(data.data.materialPermit);
//       } else {
//         toast.error("Failed to fetch material permit details");
//         navigate(-1);
//       }
//     } catch (err) {
//       toast.error("Something went wrong while fetching details");
//       navigate(-1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateStatus = async (action) => {
//     const actionText = action === "accept" ? "Accept" : "Reject";

//     const confirm = await swal({
//       title: `${actionText}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this Material In/Out?`,
//       icon: action === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: action === "reject",
//     });

//     if (!confirm) return;

//     try {
//       setUpdatingStatus(true);
//       const res = await fetch(`${API}update-material-permit-status/${materialPermit._id}`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//         body: JSON.stringify({ status: action }),
//       });
//       const data = await res.json();
//       if (res.ok) {
//         toast.success(`Material permit ${action} successfully`);
//         setMaterialPermit((prev) => ({ ...prev, status: action }));
//       } else toast.error(data.message || "Failed to update status");
//     } catch {
//       toast.error("Error updating status");
//     } finally {
//       setUpdatingStatus(false);
//     }
//   };

//   const sendGatePass = async () => {
//     try {
//       setSendingPass(true);
//       const res = await fetch(`${API}send-material-gate-pass/${materialPermit._id}`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await res.json();
//       if (res.ok) toast.success("Gate pass sent successfully");
//       else toast.error(data.message || "Failed to send gate pass");
//     } catch {
//       toast.error("Error sending gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   useEffect(() => {
//     fetchMaterialPermit();
//   }, [id, updatingStatus]);

//   const openDispatchNote = (url) => {
//     window.open(url, "_blank");
//   };

//   if (loading)
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="70vh">
//         <CircularProgress />
//       </Box>
//     );

//   if (!materialPermit)
//     return (
//       <Typography textAlign="center" variant="h6" color="text.secondary">
//         No details found.
//       </Typography>
//     );

//   const {
//     companyName,
//     department,
//     driverName,
//     email,
//     date,
//     formType,
//     govNumber,
//     mobilNumber,
//     nationality,
//     purpose,
//     vehicleNumber,
//     vehicleType,
//     materials,
//     qrCode,
//     scanHistory,
//     status,
//     createdAt,
//     updatedAt,
//     dispatchNotes,
//   } = materialPermit;

//   return (
//     <MainCard>
//       <Grid container spacing={3}>
//         {/* Header */}
//         <Grid item xs={12}>
//           <Box
//             sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}
//           >
//             <Stack direction="row" spacing={2} alignItems="center">
//               <Avatar sx={{ bgcolor: "primary.main", color: "#fff", width: 60, height: 60 }}>
//                 M
//               </Avatar>
//               <Box>
//                 <Typography variant="h5" fontWeight={600}>
//                   {driverName}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   {department.name}
//                 </Typography>
//               </Box>
//             </Stack>
//             {getStatusChip(status)}
//           </Box>
//         </Grid>

//         {/* General Info */}
//         <Grid item xs={12}>
//           <Paper
//             sx={{ border: "1px solid #2196f3", borderRadius: 2, background: "#f9fbff", p: 2.5 }}
//           >
//             <Typography variant="subtitle1" fontWeight={600} mb={1}>
//               General Information
//             </Typography>
//             <Divider sx={{ mb: 2 }} />
//             <Grid container spacing={2}>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Company:</b> {companyName}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Email:</b> {email}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Nationality:</b> {nationality}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Gov Number:</b> {govNumber}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Mobile:</b> {mobilNumber}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Form Type:</b> {formType}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Date:</b> {formatDate(date)}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Purpose:</b> {purpose || "-"}
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* Vehicle Info */}
//         <Grid item xs={12}>
//           <Paper
//             sx={{ border: "1px solid #4caf50", borderRadius: 2, background: "#f6fff7", p: 2.5 }}
//           >
//             <Typography variant="subtitle1" fontWeight={600} mb={1}>
//               Vehicle Information
//             </Typography>
//             <Divider sx={{ mb: 2 }} />
//             <Typography>
//               <b>Type:</b> {vehicleType}
//             </Typography>
//             <Typography>
//               <b>Number:</b> {vehicleNumber}
//             </Typography>
//           </Paper>
//         </Grid>

//         {/* Materials */}
//         {materials?.length > 0 && (
//           <Grid item xs={12}>
//             <Paper
//               sx={{ border: "1px solid #ff9800", borderRadius: 2, background: "#fffaf4", p: 2.5 }}
//             >
//               <Typography variant="subtitle1" fontWeight={600} mb={1}>
//                 Materials
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               {materials.map((m) => (
//                 <Box key={m._id} sx={{ mb: 1 }}>
//                   <Typography>
//                     <b>Description:</b> {m.description}
//                   </Typography>
//                   <Typography>
//                     <b>Serial No:</b> {m.serialNo}
//                   </Typography>
//                   <Typography>
//                     <b>Quantity:</b> {m.quantity}
//                   </Typography>
//                   <Divider sx={{ my: 1 }} />
//                 </Box>
//               ))}
//             </Paper>
//           </Grid>
//         )}

//         {/* QR Code */}
//         {qrCode?.url && (
//           <Grid item xs={12}>
//             <Paper
//               sx={{ border: "1px solid #e0e0e0", p: 2.5, textAlign: "center", borderRadius: 2 }}
//             >
//               <img
//                 src={qrCode.url}
//                 alt="QR Code"
//                 style={{ width: 160, height: 160, border: "1px solid #ddd", borderRadius: 12 }}
//               />
//               <Typography variant="subtitle1" color="text.secondary" mt={1}>
//                 QR Code for Material {formType} Permit
//               </Typography>
//             </Paper>
//           </Grid>
//         )}

//         {/* Dispatch Notes */}
//         {dispatchNotes?.length > 0 && (
//           <Grid item xs={12}>
//             <Paper
//               sx={{ border: "1px solid #9c27b0", borderRadius: 2, background: "#f3e5f5", p: 2.5 }}
//             >
//               <Typography variant="subtitle1" fontWeight={600} mb={1}>
//                 Dispatch Notes
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               {dispatchNotes.map((note) => (
//                 <Box key={note._id} sx={{ mb: 1 }}>
//                   <Button
//                     variant="text"
//                     color="primary"
//                     onClick={() => openDispatchNote(note.url)}
//                     sx={{ textTransform: "none", justifyContent: "flex-start" }}
//                   >
//                     <Typography>
//                       <b>{note.originalFileName}</b>
//                     </Typography>
//                   </Button>
//                   <Divider sx={{ my: 1 }} />
//                 </Box>
//               ))}
//             </Paper>
//           </Grid>
//         )}

//         {/* Scan History */}
//         {scanHistory?.length > 0 && (
//           <Grid item xs={12}>
//             <Paper sx={{ border: "1px solid #ddd", p: 2.5, borderRadius: 2 }}>
//               <Typography variant="subtitle1" fontWeight={600} mb={1}>
//                 Scan History
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               <Box sx={{ overflowX: "auto" }}>
//                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                   <thead>
//                     <tr style={{ backgroundColor: "#f5f5f5" }}>
//                       <th style={{ padding: "8px", textAlign: "left" }}>Scan Time</th>
//                       <th style={{ padding: "8px", textAlign: "left" }}>Status Code</th>
//                       <th style={{ padding: "8px", textAlign: "left" }}>Validity</th>
//                       <th style={{ padding: "8px", textAlign: "left" }}>Reason</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {scanHistory.map((s) => (
//                       <tr key={s._id} style={{ borderBottom: "1px solid #eee" }}>
//                         <td style={{ padding: "8px" }}>{formatDate(s.scanTime)}</td>
//                         <td style={{ padding: "8px" }}>{s.statusCode}</td>
//                         <td style={{ padding: "8px" }}>
//                           {s.isValid ? (
//                             <Chip label="Valid" color="success" size="small" />
//                           ) : (
//                             <Chip label="Invalid" color="error" size="small" />
//                           )}
//                         </td>
//                         <td style={{ padding: "8px" }}>{s.reason || "-"}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </Box>
//             </Paper>
//           </Grid>
//         )}

//         {/* System Info */}
//         <Grid item xs={12}>
//           <Paper
//             sx={{ border: "1px solid #e0e0e0", backgroundColor: "#fafafa", borderRadius: 2, p: 2 }}
//           >
//             <Grid container spacing={2}>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Created At:</b> {formatDate(createdAt)}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography textAlign="right">
//                   <b>Last Updated:</b> {formatDate(updatedAt)}
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* Action Buttons */}
//         <Grid item xs={12}>
//           <Divider sx={{ mb: 2 }} />
//           <Stack direction="row" spacing={2} justifyContent="flex-start">
//             {status === "pending" && (
//               <>
//                 <Button
//                   variant="contained"
//                   sx={{ backgroundColor: "#2e7d32", "&:hover": { backgroundColor: "#1b5e20" } }}
//                   disabled={updatingStatus}
//                   onClick={() => updateStatus("accept")}
//                 >
//                   {updatingStatus ? (
//                     <CircularProgress size={20} color="inherit" />
//                   ) : (
//                     "Accept Permit"
//                   )}
//                 </Button>
//                 <Button
//                   variant="contained"
//                   sx={{ backgroundColor: "#d32f2f", "&:hover": { backgroundColor: "#b71c1c" } }}
//                   disabled={updatingStatus}
//                   onClick={() => updateStatus("reject")}
//                 >
//                   {updatingStatus ? (
//                     <CircularProgress size={20} color="inherit" />
//                   ) : (
//                     "Reject Permit"
//                   )}
//                 </Button>
//               </>
//             )}

//             {status === "accept" && (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 disabled={sendingPass}
//                 onClick={sendGatePass}
//               >
//                 {sendingPass ? <CircularProgress size={20} color="inherit" /> : "Send Gate Pass"}
//               </Button>
//             )}

//             <Button
//               variant="outlined"
//               startIcon={<ArrowBackIcon />}
//               onClick={() => navigate(-1)}
//               sx={{ borderColor: "#1976d2", color: "#1976d2" }}
//             >
//               Back To List
//             </Button>
//           </Stack>
//         </Grid>
//       </Grid>
//     </MainCard>
//   );
// };

// export default MaterialEntryExitDetails;

// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import {
//   Truck,
//   Calendar,
//   Car,
//   FileText,
//   QrCode,
//   Clock,
//   ArrowLeft,
//   CheckCircle,
//   XCircle,
//   AlertCircle,
//   Mail,
//   Building,
//   Package,
//   User,
//   Phone,
//   IdCard,
//   Globe,
// } from "lucide-react";
// import styles from "./materialEntryExitDetails.module.css";

// const MaterialEntryExitDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const API = process.env.REACT_APP_API_URL;
//   const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

//   const [materialPermit, setMaterialPermit] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [updatingStatus, setUpdatingStatus] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);
//   const [showAllMaterials, setShowAllMaterials] = useState(false);

//   const formatDate = (date) => {
//     if (!date) return "-";
//     return new Date(date).toLocaleString("en-IN", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const getStatusBadge = (status) => {
//     switch (status) {
//       case "accept":
//         return (
//           <div className={`${styles.badge} ${styles.badgeAccepted}`}>
//             <CheckCircle size={16} />
//             <span>Accepted</span>
//           </div>
//         );
//       case "reject":
//         return (
//           <div className={`${styles.badge} ${styles.badgeRejected}`}>
//             <XCircle size={16} />
//             <span>Rejected</span>
//           </div>
//         );
//       default:
//         return (
//           <div className={`${styles.badge} ${styles.badgePending}`}>
//             <AlertCircle size={16} />
//             <span>Pending</span>
//           </div>
//         );
//     }
//   };

//   const fetchMaterialPermit = async () => {
//     try {
//       const response = await fetch(`${API}material-permit-details/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await response.json();
//       if (response.ok && data?.data?.materialPermit) {
//         setMaterialPermit(data.data.materialPermit);
//       } else {
//         toast.error("Failed to fetch material permit details");
//         navigate(-1);
//       }
//     } catch (error) {
//       toast.error("Something went wrong while fetching details");
//       navigate(-1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateStatus = async (action) => {
//     const actionText = action === "accept" ? "Accept" : "Reject";

//     const confirm = await swal({
//       title: `${actionText} Material Permit?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this material ${materialPermit?.formType} permit?`,
//       icon: action === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: action === "reject",
//     });

//     if (!confirm) return;

//     try {
//       setUpdatingStatus(true);
//       const response = await fetch(
//         `${API}update-material-permit-status/${materialPermit._id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             authkey: AUTH_KEY,
//           },
//           body: JSON.stringify({ status: action }),
//         }
//       );
//       const data = await response.json();
//       if (response.ok) {
//         toast.success(`Permit ${action === "accept" ? "accepted" : "rejected"} successfully`);
//         setMaterialPermit((prev) => ({ ...prev, status: action }));
//       } else {
//         toast.error(data.message || "Failed to update status");
//       }
//     } catch (error) {
//       toast.error("Error updating status");
//     } finally {
//       setUpdatingStatus(false);
//     }
//   };

//   const sendGatePass = async () => {
//     try {
//       setSendingPass(true);
//       const response = await fetch(`${API}send-material-gate-pass/${materialPermit._id}`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await response.json();
//       if (response.ok) {
//         toast.success(`Gate pass sent successfully`);
//       } else {
//         toast.error(data.message || "Failed to send gate pass");
//       }
//     } catch (error) {
//       toast.error("Error sending gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   useEffect(() => {
//     fetchMaterialPermit();
//   }, [id, updatingStatus]);

//   if (loading) {
//     return (
//       <div className={styles.loadingContainer}>
//         <div className={styles.spinner}></div>
//       </div>
//     );
//   }

//   if (!materialPermit) {
//     return (
//       <div className={styles.noData}>
//         <p>No details found.</p>
//       </div>
//     );
//   }

//   const {
//     companyName,
//     department,
//     driverName,
//     email,
//     date,
//     formType,
//     govNumber,
//     mobilNumber,
//     nationality,
//     purpose,
//     vehicleNumber,
//     vehicleType,
//     materials,
//     qrCode,
//     scanHistory,
//     status,
//     createdAt,
//     updatedAt,
//     dispatchNotes,
//   } = materialPermit;

//   const displayedMaterials =
//     showAllMaterials || materials?.length <= 10 ? materials : materials?.slice(0, 10);

//   return (
//     <div className={styles.container}>
//       {/* Header Section */}
//       <div className={styles.header}>
//         <div className={styles.headerLeft}>
//           <div className={styles.avatar}>
//             <Truck size={32} />
//           </div>
//           <div className={styles.headerInfo}>
//             <h1 className={styles.title}>
//               Material {formType} Permit
//             </h1>
//             <div className={styles.metaInfo}>
//               <span className={styles.metaItem}>
//                 <User size={14} />
//                 {driverName}
//               </span>
//               <span className={styles.metaItem}>
//                 <Building size={14} />
//                 {companyName || "N/A"}
//               </span>
//             </div>
//           </div>
//         </div>
//         <div className={styles.headerRight}>{getStatusBadge(status)}</div>
//       </div>

//       {/* General Information Section */}
//       <div className={styles.section}>
//         <div className={styles.sectionHeader}>
//           <FileText size={20} />
//           <h2>General Information</h2>
//         </div>
//         <div className={styles.sectionContent}>
//           <div className={styles.detailsGrid}>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Company Name</span>
//               <span className={styles.value}>{companyName || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Email</span>
//               <span className={styles.value}>{email || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Department</span>
//               <span className={styles.value}>{department?.name || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Driver Name</span>
//               <span className={styles.value}>{driverName || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Nationality</span>
//               <span className={styles.value}>{nationality || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Gov Number</span>
//               <span className={styles.value}>{govNumber || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Mobile Number</span>
//               <span className={styles.value}>{mobilNumber || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Form Type</span>
//               <span className={styles.value}>{formType || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Date</span>
//               <span className={styles.value}>{formatDate(date)}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Purpose</span>
//               <span className={styles.value}>{purpose || "-"}</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Vehicle Information Section */}
//       <div className={styles.section}>
//         <div className={styles.sectionHeader}>
//           <Car size={20} />
//           <h2>Vehicle Information</h2>
//         </div>
//         <div className={styles.sectionContent}>
//           <div className={styles.vehicleCard}>
//             <div className={styles.detailsGrid}>
//               <div className={styles.detailItem}>
//                 <span className={styles.label}>Vehicle Type</span>
//                 <span className={styles.value}>{vehicleType || "-"}</span>
//               </div>
//               <div className={styles.detailItem}>
//                 <span className={styles.label}>Vehicle Number</span>
//                 <span className={styles.value}>{vehicleNumber || "-"}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Materials Section */}
//       {materials && materials.length > 0 && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <Package size={20} />
//             <h2>Materials ({materials.length})</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             {displayedMaterials.map((material, index) => (
//               <div key={material._id} className={styles.materialCard}>
//                 <div className={styles.materialHeader}>
//                   <div className={styles.materialAvatar}>
//                     {index + 1}
//                   </div>
//                   <div className={styles.materialInfo}>
//                     <h3>{material.description || "Material Item"}</h3>
//                     <div className={styles.materialMeta}>
//                       <span>
//                         <IdCard size={14} />
//                         Serial: {material.serialNo || "N/A"}
//                       </span>
//                       <span>
//                         <Package size={14} />
//                         Qty: {material.quantity || 0}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}

//             {materials.length > 10 && (
//               <div className={styles.showMoreWrapper}>
//                 <button
//                   className={styles.btnShowMore}
//                   onClick={() => setShowAllMaterials((prev) => !prev)}
//                 >
//                   {showAllMaterials ? "Show Less" : "Show More"}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Dispatch Notes Section */}
//       {dispatchNotes && dispatchNotes.length > 0 && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <FileText size={20} />
//             <h2>Dispatch Notes</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             <div className={styles.documentsGrid}>
//               {dispatchNotes.map((note) => (
//                 <div key={note._id} className={styles.documentItem}>
//                   <FileText size={16} />
//                   <div className={styles.documentInfo}>
//                     <span className={styles.documentLabel}>Dispatch Note</span>
//                     <a
//                       href={note.url}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className={styles.documentLink}
//                     >
//                       {note.originalFileName || "View Document"}
//                     </a>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* QR Code Section */}
//       {qrCode?.url && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <QrCode size={20} />
//             <h2>Material {formType} Pass QR Code</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             <div className={styles.qrCodeContainer}>
//               <img src={qrCode.url} alt="QR Code" className={styles.qrCodeImage} />
//               <p className={styles.qrCodeLabel}>Scan for {formType} Verification</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Scan History Section */}
//       {scanHistory && scanHistory.length > 0 && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <Clock size={20} />
//             <h2>Scan History</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             <div className={styles.tableWrapper}>
//               <table className={styles.table}>
//                 <thead>
//                   <tr>
//                     <th>Scan Time</th>
//                     <th>Status Code</th>
//                     <th>Validity</th>
//                     <th>Reason</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {scanHistory.map((scan) => (
//                     <tr key={scan._id}>
//                       <td>{formatDate(scan.scanTime)}</td>
//                       <td>{scan.statusCode}</td>
//                       <td>
//                         {scan.isValid ? (
//                           <span className={styles.validBadge}>Valid</span>
//                         ) : (
//                           <span className={styles.invalidBadge}>Invalid</span>
//                         )}
//                       </td>
//                       <td>{scan.reason || "-"}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* System Info */}
//       <div className={styles.systemInfo}>
//         <div className={styles.systemInfoItem}>
//           <span className={styles.label}>Created At:</span>
//           <span className={styles.value}>{formatDate(createdAt)}</span>
//         </div>
//         <div className={styles.systemInfoItem}>
//           <span className={styles.label}>Last Updated:</span>
//           <span className={styles.value}>{formatDate(updatedAt)}</span>
//         </div>
//       </div>

//       {/* Action Buttons */}
//       <div className={styles.actions}>
//         {status === "pending" && (
//           <>
//             <button
//               className={`${styles.btn} ${styles.btnAccept}`}
//               disabled={updatingStatus}
//               onClick={() => updateStatus("accept")}
//             >
//               {updatingStatus ? (
//                 <div className={styles.btnSpinner}></div>
//               ) : (
//                 <>
//                   <CheckCircle size={18} />
//                   Accept Permit
//                 </>
//               )}
//             </button>

//             <button
//               className={`${styles.btn} ${styles.btnReject}`}
//               disabled={updatingStatus}
//               onClick={() => updateStatus("reject")}
//             >
//               {updatingStatus ? (
//                 <div className={styles.btnSpinner}></div>
//               ) : (
//                 <>
//                   <XCircle size={18} />
//                   Reject Permit
//                 </>
//               )}
//             </button>
//           </>
//         )}

//         {status === "accept" && (
//           <button
//             className={`${styles.btn} ${styles.btnPrimary}`}
//             disabled={sendingPass}
//             onClick={sendGatePass}
//           >
//             {sendingPass ? (
//               <div className={styles.btnSpinner}></div>
//             ) : (
//               <>
//                 <Mail size={18} />
//                 Send Gate Pass
//               </>
//             )}
//           </button>
//         )}

//         <button
//           className={`${styles.btn} ${styles.btnOutline}`}
//           onClick={() => navigate(-1)}
//         >
//           <ArrowLeft size={18} />
//           Back To List
//         </button>
//       </div>
//     </div>
//   );
// };

// export default MaterialEntryExitDetails;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import {
  Truck,
  Calendar,
  Car,
  FileText,
  QrCode,
  Clock,
  ArrowLeft,
  CheckCircle,
  XCircle,
  AlertCircle,
  Mail,
  Building,
  Package,
  User,
  Phone,
  IdCard,
  Globe,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import styles from "./materialEntryExitDetails.module.css";

const MaterialEntryExitDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const API = process.env.REACT_APP_API_URL;
  const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

  const [materialPermit, setMaterialPermit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [sendingPass, setSendingPass] = useState(false);
  const [showAllMaterials, setShowAllMaterials] = useState(false);

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "accept":
        return (
          <div className={`${styles.badge} ${styles.badgeAccepted}`}>
            <CheckCircle size={16} />
            <span>{t("materialEntryExitDetails.status.accepted")}</span>
          </div>
        );
      case "reject":
        return (
          <div className={`${styles.badge} ${styles.badgeRejected}`}>
            <XCircle size={16} />
            <span>{t("materialEntryExitDetails.status.rejected")}</span>
          </div>
        );
      default:
        return (
          <div className={`${styles.badge} ${styles.badgePending}`}>
            <AlertCircle size={16} />
            <span>{t("materialEntryExitDetails.status.pending")}</span>
          </div>
        );
    }
  };

  const fetchMaterialPermit = async () => {
    try {
      const response = await fetch(`${API}material-permit-details/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
        },
      });
      const data = await response.json();
      if (response.ok && data?.data?.materialPermit) {
        setMaterialPermit(data.data.materialPermit);
      } else {
        toast.error(t("materialEntryExitDetails.error.fetchFailed"));
        navigate(-1);
      }
    } catch (error) {
      toast.error(t("materialEntryExitDetails.error.fetchError"));
      navigate(-1);
    } finally {
      setLoading(false);
    }
  };

  // const updateStatus = async (action) => {
  //   const actionText =
  //     action === "accept"
  //       ? t("materialEntryExitDetails.buttons.accept")
  //       : t("materialEntryExitDetails.buttons.reject");

  //   const confirm = await swal({
  //     title:
  //       action === "accept"
  //         ? t("materialEntryExitDetails.confirm.acceptTitle")
  //         : t("materialEntryExitDetails.confirm.rejectTitle"),
  //     text:
  //       action === "accept"
  //         ? t("materialEntryExitDetails.confirm.acceptText", { formType: materialPermit?.formType })
  //         : t("materialEntryExitDetails.confirm.rejectText", {
  //             formType: materialPermit?.formType,
  //           }),
  //     icon: action === "accept" ? "success" : "error",
  //     buttons: [t("materialEntryExitDetails.confirm.cancel"), actionText],
  //     dangerMode: action === "reject",
  //   });

  //   if (!confirm) return;

  //   try {
  //     setUpdatingStatus(true);
  //     const response = await fetch(`${API}update-material-permit-status/${materialPermit._id}`, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         authkey: AUTH_KEY,
  //       },
  //       body: JSON.stringify({ status: action, lang: localStorage.getItem("lang") }),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       toast.success(
  //         action === "accept"
  //           ? t("materialEntryExitDetails.toast.acceptedSuccess")
  //           : t("materialEntryExitDetails.toast.rejectedSuccess"),
  //       );
  //       setMaterialPermit((prev) => ({ ...prev, status: action }));
  //     } else {
  //       toast.error(data.message || t("materialEntryExitDetails.toast.updateError"));
  //     }
  //   } catch (error) {
  //     toast.error(t("materialEntryExitDetails.toast.updateError"));
  //   } finally {
  //     setUpdatingStatus(false);
  //   }
  // };

  // const sendGatePass = async () => {
  //   try {
  //     setSendingPass(true);
  //     const response = await fetch(`${API}send-material-gate-pass/${materialPermit._id}`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         authkey: AUTH_KEY,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ lang: localStorage.getItem("lang") }),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       toast.success(t("materialEntryExitDetails.toast.sentSuccess"));
  //     } else {
  //       toast.error(data.message || t("materialEntryExitDetails.toast.sentError"));
  //     }
  //   } catch (error) {
  //     toast.error(t("materialEntryExitDetails.toast.sentError"));
  //   } finally {
  //     setSendingPass(false);
  //   }
  // };

  const updateStatus = async (action) => {
    if (updatingStatus) return;

    // STEP 1: Language selection
    const langChoice = await swal({
      title: t("materialEntryExitDetails.chooseLanguageTitle"),
      text: t("materialEntryExitDetails.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    const actionText =
      action === "accept"
        ? t("materialEntryExitDetails.buttons.accept")
        : t("materialEntryExitDetails.buttons.reject");

    // STEP 2: Confirmation
    const confirm = await swal({
      title:
        action === "accept"
          ? t("materialEntryExitDetails.confirm.acceptTitle")
          : t("materialEntryExitDetails.confirm.rejectTitle"),
      text:
        action === "accept"
          ? t("materialEntryExitDetails.confirm.acceptText", {
              formType: materialPermit?.formType,
            })
          : t("materialEntryExitDetails.confirm.rejectText", {
              formType: materialPermit?.formType,
            }),
      icon: action === "accept" ? "success" : "error",
      buttons: [t("materialEntryExitDetails.confirm.cancel"), actionText],
      dangerMode: action === "reject",
    });

    if (!confirm) return;

    try {
      setUpdatingStatus(true);

      const response = await fetch(`${API}update-material-permit-status/${materialPermit._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
        },
        body: JSON.stringify({
          status: action,
          lang: langChoice, // ✅ explicit language
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(
          action === "accept"
            ? t("materialEntryExitDetails.toast.acceptedSuccess")
            : t("materialEntryExitDetails.toast.rejectedSuccess"),
        );

        setMaterialPermit((prev) => ({
          ...prev,
          status: action,
        }));
      } else {
        toast.error(data.message || t("materialEntryExitDetails.toast.updateError"));
      }
    } catch (error) {
      toast.error(t("materialEntryExitDetails.toast.updateError"));
    } finally {
      setUpdatingStatus(false);
    }
  };

  const sendGatePass = async () => {
    const langChoice = await swal({
      title: t("materialEntryExitDetails.chooseLanguageTitle"),
      text: t("materialEntryExitDetails.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    try {
      setSendingPass(true);
      const response = await fetch(`${API}send-material-gate-pass/${materialPermit._id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: langChoice }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(t("materialEntryExitDetails.toast.sentSuccess"));
      } else {
        toast.error(data.message || t("materialEntryExitDetails.toast.sentError"));
      }
    } catch (error) {
      toast.error(t("materialEntryExitDetails.toast.sentError"));
    } finally {
      setSendingPass(false);
    }
  };

  useEffect(() => {
    fetchMaterialPermit();
  }, [id, updatingStatus]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
      </div>
    );
  }

  if (!materialPermit) {
    return (
      <div className={styles.noData}>
        <p>{t("materialEntryExitDetails.noData")}</p>
      </div>
    );
  }

  const {
    companyName,
    department,
    driverName,
    email,
    date,
    formType,
    govNumber,
    mobilNumber,
    nationality,
    purpose,
    vehicleNumber,
    vehicleType,
    materials,
    qrCode,
    scanHistory,
    status,
    createdAt,
    updatedAt,
    dispatchNotes,
    staff_status,
  } = materialPermit;

  const displayedMaterials =
    showAllMaterials || materials?.length <= 10 ? materials : materials?.slice(0, 10);

  return (
    <div className={styles.container}>
      {/* Header Section */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.avatar}>
            <Truck size={32} />
          </div>
          <div className={styles.headerInfo}>
            <h1 className={styles.title}>
              {t("materialEntryExitDetails.headerTitle", { formType })}
            </h1>
            <div className={styles.metaInfo}>
              <span className={styles.metaItem}>
                <User size={14} />
                {driverName}
              </span>
              <span className={styles.metaItem}>
                <Building size={14} />
                {companyName || "N/A"}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.headerRight}>{getStatusBadge(status)}</div>
      </div>

      {/* General Information Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <FileText size={20} />
          <h2>{t("materialEntryExitDetails.generalInfo.title")}</h2>
        </div>
        <div className={styles.sectionContent}>
          <div className={styles.detailsGrid}>
            {[
              ["companyName", companyName],
              ["email", email],
              ["department", department?.name],
              ["driverName", driverName],
              ["nationality", nationality],
              ["govNumber", govNumber],
              ["mobilNumber", mobilNumber],
              ["formType", formType],
              ["date", formatDate(date)],
              ["purpose", purpose],
            ].map(([key, value]) => (
              <div className={styles.detailItem} key={key}>
                <span className={styles.label}>
                  {t(`materialEntryExitDetails.generalInfo.labels.${key}`)}
                </span>
                <span className={styles.value}>{value || "-"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Vehicle Information Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <Car size={20} />
          <h2>{t("materialEntryExitDetails.vehicleInfo.title")}</h2>
        </div>
        <div className={styles.sectionContent}>
          <div className={styles.vehicleCard}>
            <div className={styles.detailsGrid}>
              <div className={styles.detailItem}>
                <span className={styles.label}>
                  {t("materialEntryExitDetails.vehicleInfo.labels.vehicleType")}
                </span>
                <span className={styles.value}>{vehicleType || "-"}</span>
              </div>
              <div className={styles.detailItem}>
                <span className={styles.label}>
                  {t("materialEntryExitDetails.vehicleInfo.labels.vehicleNumber")}
                </span>
                <span className={styles.value}>{vehicleNumber || "-"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Materials Section */}
      {materials && materials.length > 0 && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <Package size={20} />
            <h2>{t("materialEntryExitDetails.materials.title", { count: materials.length })}</h2>
          </div>
          <div className={styles.sectionContent}>
            {displayedMaterials.map((material, index) => (
              <div key={material._id} className={styles.materialCard}>
                <div className={styles.materialHeader}>
                  <div className={styles.materialAvatar}>{index + 1}</div>
                  <div className={styles.materialInfo}>
                    <h3>{material.description || t("materialEntryExitDetails.materials.item")}</h3>
                    <div className={styles.materialMeta}>
                      <span>
                        <IdCard size={14} />
                        {t("materialEntryExitDetails.materials.serial")}:{" "}
                        {material.serialNo || "N/A"}
                      </span>
                      <span>
                        <Package size={14} />
                        {t("materialEntryExitDetails.materials.qty")}: {material.quantity || 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {materials.length > 10 && (
              <div className={styles.showMoreWrapper}>
                <button
                  className={styles.btnShowMore}
                  onClick={() => setShowAllMaterials((prev) => !prev)}
                >
                  {showAllMaterials
                    ? t("materialEntryExitDetails.materials.showLess")
                    : t("materialEntryExitDetails.materials.showMore")}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Dispatch Notes Section */}
      {dispatchNotes && dispatchNotes.length > 0 && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <FileText size={20} />
            <h2>{t("materialEntryExitDetails.dispatch.title")}</h2>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.documentsGrid}>
              {dispatchNotes.map((note) => (
                <div key={note._id} className={styles.documentItem}>
                  <FileText size={16} />
                  <div className={styles.documentInfo}>
                    <span className={styles.documentLabel}>
                      {t("materialEntryExitDetails.dispatch.note")}
                    </span>
                    <a
                      href={note.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.documentLink}
                    >
                      {note.originalFileName || t("materialEntryExitDetails.dispatch.viewDoc")}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* QR Code Section */}
      {qrCode?.url && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <QrCode size={20} />
            <h2>{t("materialEntryExitDetails.qr.title", { formType })}</h2>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.qrCodeContainer}>
              <img src={qrCode.url} alt="QR Code" className={styles.qrCodeImage} />
              <p className={styles.qrCodeLabel}>
                {t("materialEntryExitDetails.qr.scanText", { formType })}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Scan History Section */}
      {scanHistory && scanHistory.length > 0 && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <Clock size={20} />
            <h2>{t("materialEntryExitDetails.scanHistory.title")}</h2>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>{t("materialEntryExitDetails.scanHistory.scanTime")}</th>
                    <th>{t("materialEntryExitDetails.scanHistory.statusCode")}</th>
                    <th>{t("materialEntryExitDetails.scanHistory.validity")}</th>
                    <th>{t("materialEntryExitDetails.scanHistory.reason")}</th>
                  </tr>
                </thead>
                <tbody>
                  {scanHistory.map((scan) => (
                    <tr key={scan._id}>
                      <td>{formatDate(scan.scanTime)}</td>
                      <td>{scan.statusCode}</td>
                      <td>
                        {scan.isValid ? (
                          <span className={styles.validBadge}>
                            {t("materialEntryExitDetails.scanHistory.valid")}
                          </span>
                        ) : (
                          <span className={styles.invalidBadge}>
                            {t("materialEntryExitDetails.scanHistory.invalid")}
                          </span>
                        )}
                      </td>
                      <td>{scan.reason || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* System Info */}
      <div className={styles.systemInfo}>
        <div className={styles.systemInfoItem}>
          <span className={styles.label}>{t("materialEntryExitDetails.system.createdAt")}</span>
          <span className={styles.value}>{formatDate(createdAt)}</span>
        </div>
        <div className={styles.systemInfoItem}>
          <span className={styles.label}>{t("materialEntryExitDetails.system.updatedAt")}</span>
          <span className={styles.value}>{formatDate(updatedAt)}</span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className={styles.actions}>
        {status === "pending" && staff_status !== "reject" && (
          <>
            <button
              className={`${styles.btn} ${styles.btnAccept}`}
              disabled={updatingStatus}
              onClick={() => updateStatus("accept")}
            >
              {updatingStatus ? (
                <div className={styles.btnSpinner}></div>
              ) : (
                <>
                  <CheckCircle size={18} />
                  {t("materialEntryExitDetails.buttons.acceptPermit")}
                </>
              )}
            </button>

            <button
              className={`${styles.btn} ${styles.btnReject}`}
              disabled={updatingStatus}
              onClick={() => updateStatus("reject")}
            >
              {updatingStatus ? (
                <div className={styles.btnSpinner}></div>
              ) : (
                <>
                  <XCircle size={18} />
                  {t("materialEntryExitDetails.buttons.rejectPermit")}
                </>
              )}
            </button>
          </>
        )}
        {status === "accept" && (
          <button
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={sendingPass}
            onClick={sendGatePass}
          >
            {sendingPass ? (
              <div className={styles.btnSpinner}></div>
            ) : (
              <>
                <Mail size={18} />
                {t("materialEntryExitDetails.buttons.sendGatePass")}
              </>
            )}
          </button>
        )}

        <button className={`${styles.btn} ${styles.btnOutline}`} onClick={() => navigate(-1)}>
          <ArrowLeft size={18} />
          {t("materialEntryExitDetails.buttons.backToList")}
        </button>
      </div>
    </div>
  );
};

export default MaterialEntryExitDetails;
